export const APP_CONFIG = {
  appName: 'NIHIP',
  frontend: 'https://nihip.org',
  apiHash: 'https://nihip.org/api/1.0',
  api: '/api/2.0',
  commitSHA: '85eee62',
  trustModel: false,
  authHeaders: {
    xServiceProvider: 'nihip-prod-frontend',
    'tenant-id': '03f32412-a33a-49d1-b1b3-aedc9ba73e04',
    'consumer-id': 'f45f8cbf-1207-4598-b376-2dfb83b4ef81',
  },
  provider: 'nihip-prod-frontend',
  multilingual: false,
  demoMode: false,
  chatEnabled: false,
  readabilityEnabled: false,
  gtm: 'GTM-TT9PGDVV',
  copyright: '<small>&copy; ' + new Date().getFullYear() +
      ' Gallagher | All Rights Reserved.' + '<br />Powered by Core.' + '</small>',
  navigation: {
    navType: 'top',
    collapsibleSidenav: false,
    headerStyle: 'solid',
    categoryNav: true,
    navigationOrder: 'displayOrder',
  },
};
